// Blog post metadata. Posts live in code: to publish a post, add ./meta/<slug>.ts (metadata),
// ./html/<slug>.ts (body) and a cover spec in scripts/blog-images/specs/<slug>.mjs, then run
//   node scripts/blog-images/render.mjs --only <slug>
//   node --experimental-strip-types scripts/blog-sync.mjs
// which regenerates the index at the bottom of this file. Retired or renamed URLs go in
// ./redirects.ts. Pure data so /api can import it.
//
// SEO conventions: `title` is the H1 and leads with the primary keyword; `seoTitle` fits in
// 62 characters once " | Beatview" is appended; `seoDescription` is 120–160 characters;
// `takeaways` and `faqs` are rendered on the page and mirrored in JSON-LD, so keep them factual.

export interface BlogFaq {
  question: string;
  answer: string;
}

export interface BlogPostMeta {
  slug: string;
  /** H1 on the page. */
  title: string;
  /** Short standfirst under the H1 and on cards (max ~220 characters). */
  excerpt: string;
  /** Must match a name in src/lib/blogCategories.ts. */
  category: string;
  /** Search phrase this article is written to rank for. */
  primaryKeyword: string;
  /** Secondary phrases covered in the article (used as schema keywords). */
  tags: string[];
  author: string;
  publishedAt: string;
  updatedAt: string;
  seoTitle: string;
  seoDescription: string;
  /** Minutes; recomputed by scripts/blog-sync.mjs. */
  readingTime: number;
  /** Site-relative 1200×630 cover rendered by scripts/blog-images. */
  cover: string;
  coverAlt: string;
  /** Answer-first summary shown above the article. */
  takeaways: string[];
  faqs: BlogFaq[];
  /** Slugs to show first under "Related articles". */
  related?: string[];
}

// ── Index below is generated by scripts/blog-sync.mjs ──
import meta0 from './meta/ai-hiring-laws.js';
import meta1 from './meta/ai-hiring-software.js';
import meta2 from './meta/ai-in-recruitment.js';
import meta3 from './meta/ai-interview-software.js';
import meta4 from './meta/ai-recruiting-dashboard.js';
import meta5 from './meta/ai-resume-screening-tools.js';
import meta6 from './meta/ai-resume-screening.js';
import meta7 from './meta/asynchronous-video-interview.js';
import meta8 from './meta/beatview-vs-hirevue.js';
import meta9 from './meta/beatview-vs-spark-hire.js';
import meta10 from './meta/bias-in-hiring.js';
import meta11 from './meta/boolean-search-for-recruiters.js';
import meta12 from './meta/candidate-screening-process.js';
import meta13 from './meta/contract-to-hire.js';
import meta14 from './meta/explainable-ai-in-recruiting.js';
import meta15 from './meta/headhunter-vs-recruiter.js';
import meta16 from './meta/high-volume-recruiting.js';
import meta17 from './meta/how-staffing-agencies-work.js';
import meta18 from './meta/how-to-rank-candidates.js';
import meta19 from './meta/how-to-reduce-time-to-hire.js';
import meta20 from './meta/how-to-screen-resumes.js';
import meta21 from './meta/how-to-shortlist-candidates.js';
import meta22 from './meta/interview-automation.js';
import meta23 from './meta/interview-scorecard-template.js';
import meta24 from './meta/one-way-video-interview-vs-ai-interviewer.js';
import meta25 from './meta/recruitment-agency-marketing.js';
import meta26 from './meta/recruitment-business-development.js';
import meta27 from './meta/recruitment-metrics.js';
import meta28 from './meta/recruitment-workflow.js';
import meta29 from './meta/resume-screening-software.js';
import meta30 from './meta/retained-vs-contingency-search.js';
import meta31 from './meta/screening-interview-questions.js';
import meta32 from './meta/skills-based-hiring-vs-resume-screening.js';
import meta33 from './meta/structured-hiring-process.js';
import meta34 from './meta/structured-interview-questions.js';
import meta35 from './meta/structured-interviews.js';
import meta36 from './meta/time-to-fill.js';
import meta37 from './meta/video-interview-questions.js';
import meta38 from './meta/video-interview-software.js';
import meta39 from './meta/what-is-an-ai-interview.js';

export const BLOG_POSTS: BlogPostMeta[] = [
  meta0,
  meta1,
  meta2,
  meta3,
  meta4,
  meta5,
  meta6,
  meta7,
  meta8,
  meta9,
  meta10,
  meta11,
  meta12,
  meta13,
  meta14,
  meta15,
  meta16,
  meta17,
  meta18,
  meta19,
  meta20,
  meta21,
  meta22,
  meta23,
  meta24,
  meta25,
  meta26,
  meta27,
  meta28,
  meta29,
  meta30,
  meta31,
  meta32,
  meta33,
  meta34,
  meta35,
  meta36,
  meta37,
  meta38,
  meta39,
];
